/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from "@emotion/core";
import React, { useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux';
import { Modal } from 'react-bootstrap';
import { pushToSetting } from '../../../redux/slices/SettingSclice';
import { fetchGlobalSetting, setSetting } from '../../../Components/action/common';

const FeatureUpdateModal = ({preview = false, setPreview = () => {}}) => {
    const theme = useSelector(state => state.theme.theme);
    const {settings} = useSelector(state => state.settings);
    const [notification, setNotification] = useState(null);
    const dispatch = useDispatch();

    useEffect(() => {
        if(preview !== false){
            setNotification(preview)
        }else{
            fetchGlobalSetting({settings: 'newFeatureText,newFeatureVersion'}).then(async(res) => {
            let newFeatureText = null;
            let newFeatureVersion = null;
            res?.data?.responseData?.map(setting => {
                newFeatureText = setting?.settingName == "newFeatureText" ? setting?.settingValue : newFeatureText;
                newFeatureVersion = setting?.settingName == "newFeatureVersion" ? setting?.settingValue : newFeatureVersion;
            })
            
            if(newFeatureVersion != settings?.appVersion && newFeatureVersion == process.env.REACT_APP_VERSION){
                setNotification(newFeatureText);
                // Update settings
                const newSettings = { ...settings, appVersion: newFeatureVersion };
                await setSetting({ "settings": newSettings })
                dispatch(pushToSetting(newSettings));
                }
            }).catch(e => {});
        }
    }, [preview]);

    return (
        notification !== null &&
        <Modal show={true} className="task-modal file-upload-modal !transform-none absolute !top-[10%]"  css={{
            '.notification-text':{
                a: {
                    color: `var(--accent-color) !important`
                }
            }
        }}>
            <Modal.Body className="modal-body-extra-padding">
                <div className="full-model md-model-updates block">
                    <div className="full-model-body">
                        <div className="notification-text">
                            <h3 className="darkPrimaryColor">What’s New</h3>
                            <div className="max-h-[60vh] overflow-y-auto">
                                <div className="body-data mt-5" dangerouslySetInnerHTML={{ __html: notification }} />
                            </div>
                        </div>
                        <div className="mt-10 flex justify-end items-end">
                            <button className="button light-btn "
                                onClick={() => preview !== false ? setPreview(false) : setNotification(null)}
                                css={{
                                    background: 'none !important',
                                    color: `var(--accent-color) !important`
                            }}
                            >Close</button>
                        </div>
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    )
}

export default FeatureUpdateModal